module.exports = __webpack_public_path__ + "img/logo_u1992-30.645b243e.png";